import 'application/bootstrap'

if (module.hot) {
  module.hot.accept()
}
// 禁用鼠标右键
// document.addEventListener('contextmenu', function (e) {
//   e.preventDefault()
// })



// WEBPACK FOOTER //
// ./src/index.js